import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';

/**
 * Confirmation dialog before revoking Canvas admin access (row or bulk).
 */
const StaffCanvasAccessRemoveConfirmDialog = ({
  open,
  title = 'Remove Canvas access',
  message,
  submitting = false,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={submitting ? undefined : onCancel}
    maxWidth="sm"
    fullWidth
    data-testid="staff-canvas-access-remove-confirm"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText style={{ whiteSpace: 'pre-line' }}>
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel} disabled={submitting}>
        Cancel
      </Button>
      <Button
        color="secondary"
        variant="contained"
        onClick={onConfirm}
        disabled={submitting}
        data-testid="staff-canvas-access-remove-confirm-button"
      >
        Remove access
      </Button>
    </DialogActions>
  </Dialog>
);

StaffCanvasAccessRemoveConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default StaffCanvasAccessRemoveConfirmDialog;
